import { Skeleton } from "@mui/material";
import { BlockCard, DonutChartSkeleton } from "../primitives";
import styles from "./style.module.scss";

interface AssignmentPipelineBlockSkeletonProps {
  count?: number;
  className?: string;
}

function AssignmentPipelineBlockSkeleton({
  count = 4,
  className,
}: AssignmentPipelineBlockSkeletonProps) {
  return (
    <BlockCard
      title={<Skeleton variant="text" width={175} height={26} />}
      headerTight
      className={className}
    >
      <div className={styles.body}>
        <DonutChartSkeleton size={130} />
        <div className={styles.legend}>
          {Array.from({ length: count }).map((_, index) => (
            <div key={index} className={styles.legendRow}>
              <Skeleton variant="rounded" width={12} height={12} />
              <Skeleton variant="text" width="65%" height={18} />
              <Skeleton variant="text" width={24} height={18} />
              <Skeleton variant="text" width={30} height={18} />
            </div>
          ))}
        </div>
      </div>
    </BlockCard>
  );
}

export default AssignmentPipelineBlockSkeleton;
